module.exports = __webpack_public_path__ + "img/raf-main-eligible.e52cafd.svg";